import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const RSVTestResults = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-4 py-lg-5 py-md-2'>
            <Row className='reverse-section pt-md-0 pt-3'>
                <Col md='12' lg='6' className='pt-md-5 pb-md4 '>
                    <div className='flex-center'>
                        <img src='rsv-testing/RSV-Testing-img1.webp' alt='' height='' width='' className='img-w17' />
                    </div>
                </Col>
                <Col md='12' lg='6' className=''>
                    <div className=''>
                        <div className='pb-2'>
                            <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                                RSV TEST RESULTS
                            </div>
                            <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>

                        <div className=''>
                            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                There are two RSV test results:
                            </div>
                        </div>

                        <div className='pt-3 pb-2'>
                            <ul className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                               <li className='pb-1'>
                                    A <strong>negative result</strong> indicates that your sample did not contain any signs of the RSV virus. They might suggest that another illness brings on your symptoms.    However, RSV is still possible despite a negative test result.
                               </li> 

                               <li className=''>
                                   If your test comes back positive, you likely have an RSV infection.
                               </li> 
                            </ul>
                        </div>

                        <div className='flex-center1 pb-md-0 pb-4'>
                        <Link to='/book-panel-test-appointment'>
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <text className='text-montserrat fw-600 fs-ss-16' style={{ padding:'12px 14px',}}>
                                    SCHEDULE YOUR TEST
                                </text>
                            </Button>
                        </Link>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default RSVTestResults